import React from 'react';
import './M3FAB.css';

/**
 * M3 FAB — Standard (56px) and Extended (48px + label).
 *
 * @param {'standard'|'extended'} [size='standard']
 * @param {'primary'|'secondary'|'tertiary'|'surface'} [variant='primary']
 * @param {boolean} [expanded] — for extended FAB, controls label visibility
 * @param {ReactNode} [icon] — required for standard, optional for extended
 * @param {ReactNode} [label] — for extended FAB
 * @param {Function} [onClick]
 */
export default function M3FAB({
  size = 'standard',
  variant = 'primary',
  expanded = true,
  icon,
  label,
  onClick,
  className = '',
  ...props
}) {
  const isExtended = size === 'extended';

  return (
    <button
      className={`m3-fab m3-fab-${variant} ${
        isExtended ? 'm3-fab-extended' : 'm3-fab-standard'
      } ${className}`}
      onClick={onClick}
      {...props}
    >
      {icon && <span className="m3-fab-icon">{icon}</span>}
      {label && expanded && <span className="m3-fab-label">{label}</span>}
    </button>
  );
}

/**
 * Quick extended FAB with icon + label.
 */
export function FAB({ icon, label, variant = 'primary', onClick, className }) {
  return (
    <M3FAB
      size="extended"
      variant={variant}
      icon={icon}
      label={label}
      onClick={onClick}
      className={className}
    />
  );
}
